import { render } from "./PipelineS3AccessSetup.vue?vue&type=template&id=2ef030ae"
import script from "./PipelineS3AccessSetup.vue?vue&type=script&lang=js"
export * from "./PipelineS3AccessSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__